/* Pixie Pack en kleurenkiezer, RK Creative Solutions.

   De kortingscode komt uit de config. Staat daar niets, dan gebruikt de
   knop PIXIEPACK31, wat de Pixie Pack pagina is. De kleurenkiezer op de
   losse kleurpagina's zet code op leeg, want daar geldt de automatische
   5 plus 1 van Shopify en is geen code nodig.                          */
(function(){

  function videosOmzetten(){
    var wrap = document.querySelector('.pprk');
    if(!wrap) return;
    wrap.querySelectorAll('img').forEach(function(img){
      var src = img.getAttribute('src') || '';
      if(!/\.(mp4|mov|webm)(\?|$)/i.test(src)) return;
      var v = document.createElement('video');
      v.src = src;
      v.controls = true; v.playsInline = true;
      v.setAttribute('playsinline',''); v.setAttribute('preload','metadata');
      v.className = img.className;
      if(img.getAttribute('alt')) v.setAttribute('aria-label', img.getAttribute('alt'));
      var s = window.getComputedStyle(img);
      v.style.width = '100%'; v.style.display = 'block'; v.style.objectFit = 'cover';
      if(s.borderRadius && s.borderRadius !== '0px') v.style.borderRadius = s.borderRadius;
      if(s.aspectRatio && s.aspectRatio !== 'auto') v.style.aspectRatio = s.aspectRatio;
      img.parentNode.replaceChild(v, img);
    });
  }
  function init(){ videosOmzetten(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);

  var root = document.querySelector('[data-pprk]');
  if(!root) return;
  var cfgEl = root.querySelector('[data-pprk-config]');
  if(!cfgEl) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var kleuren = cfg.kleuren || [];
  var PACK = cfg.packPrijs, KLEUR = cfg.kleurPrijs, GRATIS_NA = cfg.gratisNa || 3;

  var TELT_MEE = cfg.packTeltMee === true;
  var EERSTE_HALF = cfg.eersteHalf === true;
  var CODE = cfg.code === undefined ? 'PIXIEPACK31' : cfg.code;

  var gekozen = [];

  var recap = root.querySelector('[data-pprk-recap]');
  var bar = root.querySelector('[data-pprk-bar]');
  var barLbl = root.querySelector('[data-pprk-barlabel]');
  var atc = root.querySelector('[data-pprk-atc]');
  var stickyBtn = root.querySelector('[data-pprk-sticky-atc]');
  var stickyPr = root.querySelector('[data-pprk-sticky-price]');
  var sticky = root.querySelector('[data-pprk-sticky]');
  var toast = root.querySelector('[data-pprk-toast]');
  var alleBox = root.querySelector('[data-pprk-all]');
  var meerBtn = root.querySelector('[data-pprk-more]');
  if(!atc || !recap) return;

  var pv = document.createElement('div');
  pv.className = 'pprk pprk__pv';
  pv.innerHTML = '<img alt=""><b></b><span></span>';
  document.body.appendChild(pv);
  var pvImg = pv.querySelector('img'), pvNaam = pv.querySelector('b'), pvPrijs = pv.querySelector('span');

  function getal(centen, dec, duiz, decimalen){
    var neg = centen < 0;
    var v = (Math.abs(centen)/100).toFixed(decimalen);
    var d = v.split('.');
    var heel = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, duiz);
    return (neg ? '-' : '') + heel + (d[1] ? dec + d[1] : '');
  }
  function geld(centen){
    var f = cfg.valuta || '\u20ac{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*([a-z_0-9]+)\s*\}\}/gi, function(_, naam){
      switch(naam){
        case 'amount': return getal(centen,'.',',',2);
        case 'amount_no_decimals': return getal(centen,'.',',',0);
        case 'amount_with_comma_separator': return getal(centen,',','.',2);
        case 'amount_no_decimals_with_comma_separator': return getal(centen,',','.',0);
        case 'amount_with_apostrophe_separator': return getal(centen,'.',"'",2);
        case 'amount_no_decimals_with_space_separator': return getal(centen,',',' ',0);
        case 'amount_with_space_separator': return getal(centen,',',' ',2);
        case 'amount_with_period_and_space_separator': return getal(centen,'.',' ',2);
        default: return getal(centen,',','.',2);
      }
    });
  }

  root.querySelectorAll('[data-pprk-index]').forEach(function(b){
    var i = parseInt(b.getAttribute('data-pprk-index'),10);
    var k = kleuren[i];
    if(!k) return;
    if(!k.inPack){ b.addEventListener('click', function(){ kies(i,b); }); }
    b.addEventListener('mouseenter', function(){ toonPv(k,b); });
    b.addEventListener('focus', function(){ toonPv(k,b); });
    b.addEventListener('mouseleave', hidePv);
    b.addEventListener('blur', hidePv);
  });

  function toonPv(k, el){
    pvImg.src = k.hover || k.img;
    pvImg.alt = k.naam;
    pvNaam.textContent = k.naam;
    if(k.inPack){ pvPrijs.textContent = cfg.tekstInPack; }
    else if(EERSTE_HALF && gekozen.length === 0){
      pvPrijs.textContent = geld(Math.round(KLEUR/2)) + ' ' + cfg.tekstIpv + ' ' + geld(KLEUR);
    } else { pvPrijs.textContent = geld(KLEUR); }
    var r = el.getBoundingClientRect(), w = 140, h = 196, m = 12;
    var l = Math.max(8, Math.min(r.left + r.width/2 - w/2, window.innerWidth - w - 8));
    var boven = r.top - h - m;
    if(boven < 8){ pv.style.top = (r.bottom + m) + 'px'; pv.classList.add('is-below'); pv.classList.remove('is-above'); }
    else { pv.style.top = boven + 'px'; pv.classList.add('is-above'); pv.classList.remove('is-below'); }
    pv.style.left = l + 'px';
    pv.classList.add('is-on');
  }
  function hidePv(){ pv.classList.remove('is-on'); }

  function kies(i, el){
    var p = gekozen.indexOf(i);
    if(p > -1){ gekozen.splice(p,1); }
    else { gekozen.push(i); melding(kleuren[i].naam + ' ' + cfg.tekstToegevoegd); }
    root.querySelectorAll('[data-pprk-index="' + i + '"]').forEach(function(b){
      b.setAttribute('aria-pressed', p > -1 ? 'false' : 'true');
    });
    render();
    if(window.matchMedia('(hover: none)').matches){
      toonPv(kleuren[i], el);
      clearTimeout(el._t); el._t = setTimeout(hidePv, 1600);
    }
  }

  if(meerBtn && alleBox){
    meerBtn.addEventListener('click', function(){
      var open = alleBox.classList.toggle('is-open');
      meerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(open){
        alleBox.querySelectorAll('img[data-src]').forEach(function(im){
          im.src = im.getAttribute('data-src'); im.removeAttribute('data-src');
        });
      }
    });
    var sluit = root.querySelector('[data-pprk-all-close]');
    if(sluit) sluit.addEventListener('click', function(){
      alleBox.classList.remove('is-open');
      meerBtn.setAttribute('aria-expanded','false');
    });
    var grid = alleBox.querySelector('.pprk__all-grid');
    if(grid) grid.addEventListener('scroll', hidePv, {passive:true});
  }

  function bereken(){
    var regels = [{t: cfg.packNaam, p: PACK, k: ''}];
    var totaal = PACK, bespaard = 0, stap = GRATIS_NA + 1;
    var start = TELT_MEE ? 2 : 1;

    for(var j = 0; j < gekozen.length; j++){
      var positie = start + j;
      var prijs = KLEUR, tag = '';
      if(EERSTE_HALF && j === 0){ prijs = Math.round(KLEUR/2); tag = 'is-off'; }
      if(positie % stap === 0){ prijs = 0; tag = 'is-free'; }
      bespaard += (KLEUR - prijs); totaal += prijs;
      regels.push({t: kleuren[gekozen[j]].naam, p: prijs, k: tag});
    }
    return {regels: regels, totaal: totaal, bespaard: bespaard,
            n: gekozen.length, stuks: gekozen.length + (TELT_MEE ? 1 : 0)};
  }

  function render(){
    var r = bereken(), html = '';
    if(r.n === 0){ html = '<p class="pprk__empty">' + cfg.tekstLeeg + '</p>'; }
    else {
      r.regels.forEach(function(l){
        var lbl = l.k === 'is-free' ? cfg.tekstGratis
          : (l.k === 'is-off' ? geld(l.p) + ' <s style="opacity:.5">' + geld(KLEUR) + '</s>' : geld(l.p));
        html += '<div class="pprk__rl ' + l.k + '"><span>' + l.t + '</span><span>' + lbl + '</span></div>';
      });
      html += '<div class="pprk__rt"><span>' + cfg.tekstTotaal + '</span><span>' + geld(r.totaal) + '</span></div>';
      if(r.bespaard > 0){ html += '<div class="pprk__rl is-off" style="padding-top:6px"><span>' + cfg.tekstBespaard + '</span><span>' + geld(r.bespaard) + '</span></div>'; }
    }
    recap.innerHTML = html;

    var stap = GRATIS_NA + 1, mod = r.stuks % stap, pct = (mod/GRATIS_NA)*100;
    if(mod === 0 && r.stuks > 0) pct = 100;
    if(bar) bar.style.width = Math.min(pct,100) + '%';
    if(barLbl){
      if(r.stuks === 0) barLbl.textContent = cfg.tekstNog.replace('{n}', GRATIS_NA);
      else if(mod === 0) barLbl.innerHTML = '<b>' + cfg.tekstGelukt + '</b>';
      else if(mod === GRATIS_NA) barLbl.innerHTML = '<b>' + cfg.tekstEenMeer + '</b>';
      else barLbl.textContent = cfg.tekstNog.replace('{n}', GRATIS_NA - mod);
    }
    atc.textContent = cfg.tekstMandje + ' \u00b7 ' + geld(r.totaal);
    if(stickyPr) stickyPr.textContent = geld(r.totaal) + (r.n ? ' \u00b7 ' + r.n + ' ' + (r.n > 1 ? cfg.tekstKleuren : cfg.tekstKleur) : '');
  }

  var tTimer;
  function melding(m){
    if(!toast) return;
    toast.textContent = m; toast.classList.add('is-on');
    clearTimeout(tTimer); tTimer = setTimeout(function(){ toast.classList.remove('is-on'); }, 1800);
  }

  /* ---------- toevoegen aan mandje ----------
     Een echt formulier naar /cart/add. De browser verlaat de pagina, dus
     geen zijmandje kan ertussen komen. Is er een kortingscode nodig, dan
     loopt de terugweg via /discount/CODE zodat Shopify die toepast en
     daarna zelf het mandje toont.                                       */
  function naarMandje(e){
    e.preventDefault();
    e.stopPropagation();
    atc.setAttribute('disabled','');
    if(stickyBtn) stickyBtn.setAttribute('disabled','');

    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.enctype = 'application/x-www-form-urlencoded';
    f.style.display = 'none';

    function veld(naam, waarde){
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = naam; i.value = waarde;
      f.appendChild(i);
    }
    veld('items[0][id]', cfg.packVariant);
    veld('items[0][quantity]', '1');
    gekozen.forEach(function(k, j){
      veld('items[' + (j+1) + '][id]', kleuren[k].variant);
      veld('items[' + (j+1) + '][quantity]', '1');
    });

    var stuks = gekozen.length + (TELT_MEE ? 1 : 0);
    if(CODE && stuks > GRATIS_NA){
      veld('return_to', '/discount/' + CODE + '?redirect=/cart');
    } else {
      veld('return_to', '/cart');
    }

    document.body.appendChild(f);
    HTMLFormElement.prototype.submit.call(f);
  }
  atc.addEventListener('click', naarMandje);
  if(stickyBtn) stickyBtn.addEventListener('click', naarMandje);
  window.addEventListener('pageshow', function(e){
    if(e.persisted){
      atc.removeAttribute('disabled');
      if(stickyBtn) stickyBtn.removeAttribute('disabled');
    }
  });

  /* ---------- galerij met pijlen ---------- */
  var thumbs = root.querySelector('[data-pprk-thumbs]');
  var galMain = root.querySelector('[data-pprk-galmain]');
  if(thumbs && galMain && thumbs.children.length > 1){
    var houder = galMain.parentElement;
    var pijl = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="P"/></svg>';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'pprk__galnav pprk__galnav--prev';
    prev.setAttribute('aria-label','Vorige');
    prev.innerHTML = pijl.replace('P','15 18 9 12 15 6');
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'pprk__galnav pprk__galnav--next';
    next.setAttribute('aria-label','Volgende');
    next.innerHTML = pijl.replace('P','9 18 15 12 9 6');
    var teller = document.createElement('span');
    teller.className = 'pprk__galcount';
    houder.appendChild(prev); houder.appendChild(next); houder.appendChild(teller);

    var galBtns = Array.prototype.slice.call(thumbs.children), galI = 0;
    var dots = root.querySelector('[data-pprk-dots]');
    if(dots){
      galBtns.forEach(function(_, i){
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label','Foto ' + (i+1));
        d.addEventListener('click', function(){ galToon(i); });
        dots.appendChild(d);
      });
    }

    var galToon = function(i){
      galI = (i + galBtns.length) % galBtns.length;
      galBtns.forEach(function(c){ c.classList.remove('is-on'); });
      var b = galBtns[galI];
      b.classList.add('is-on');
      var vol = b.getAttribute('data-pprk-full');
      var huidig = houder.querySelector('[data-pprk-galmain], video.pprk__galmain');
      if(/\.(mp4|mov|webm)(\?|$)/i.test(vol)){
        if(huidig.tagName !== 'VIDEO'){
          var v = document.createElement('video');
          v.className = huidig.className;
          v.controls = true; v.playsInline = true;
          v.setAttribute('playsinline',''); v.setAttribute('preload','metadata');
          v.setAttribute('data-pprk-galmain','');
          huidig.parentNode.replaceChild(v, huidig);
          huidig = v;
        }
        huidig.src = vol;
      } else {
        if(huidig.tagName === 'VIDEO'){
          var im = document.createElement('img');
          im.className = huidig.className;
          im.setAttribute('data-pprk-galmain','');
          huidig.parentNode.replaceChild(im, huidig);
          huidig = im;
        }
        huidig.src = vol;
      }
      teller.textContent = (galI + 1) + ' / ' + galBtns.length;
      if(dots){ Array.prototype.forEach.call(dots.children, function(d, j){ d.classList.toggle('is-on', j === galI); }); }
      b.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'});
    };

    thumbs.addEventListener('click', function(e){
      var b = e.target.closest('button');
      if(b) galToon(galBtns.indexOf(b));
    });
    prev.addEventListener('click', function(){ galToon(galI - 1); });
    next.addEventListener('click', function(){ galToon(galI + 1); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft') galToon(galI - 1);
      if(e.key === 'ArrowRight') galToon(galI + 1);
    });
    var tx = null;
    houder.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; }, {passive:true});
    houder.addEventListener('touchend', function(e){
      if(tx === null) return;
      var d = e.changedTouches[0].clientX - tx;
      if(Math.abs(d) > 45) galToon(galI + (d < 0 ? 1 : -1));
      tx = null;
    }, {passive:true});
    galToon(0);
  }

  var faq = root.querySelector('[data-pprk-faq]');
  if(faq){
    faq.addEventListener('click', function(e){
      var q = e.target.closest('.pprk__fq'); if(!q) return;
      var item = q.parentElement, a = item.querySelector('.pprk__fa');
      var open = item.classList.contains('is-open');
      item.classList.toggle('is-open', !open);
      a.style.maxHeight = open ? 0 : a.scrollHeight + 'px';
    });
  }

  if(sticky){
    window.addEventListener('scroll', function(){
      var r = atc.getBoundingClientRect();
      sticky.classList.toggle('is-on', r.bottom < 0);
      hidePv();
    }, {passive:true});
  }

  render();
})();